// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/styles.css
// module id = 1576
// module chunks = 228